import type { NavigateFunction } from "react-router-dom"

import { ALL_APPLICATIONS_ROUTES_CONFIG } from "../../config/config"

export const switchApplication =
  (input: { navigate: NavigateFunction })=>
  (value: string)=> {
    const newRoute = ALL_APPLICATIONS_ROUTES_CONFIG.find(x=> x.key === value)
    if (newRoute?.route) {
      input.navigate(newRoute.route)
    }
  }
